import React from "react";
import { TimeDeltaDynamicZoneModel } from "@models/strapi-components/time-delta";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import FlipClockCountdown from "@leenguyen/react-flip-clock-countdown";
import "@leenguyen/react-flip-clock-countdown/dist/index.css";
import Title from "@components/common/Title";
import { useWindowSize } from "@uidotdev/usehooks";

dayjs.extend(relativeTime);

type Props = {
  componentData: TimeDeltaDynamicZoneModel;
};

export const TimeDelta: React.FC<Props> = ({ componentData }) => {
  const { title, targetDate, bgColor, textColor, blockColor } = componentData;

  const { width } = useWindowSize();

  const blockWidth = (() => {
    if (!width) return 60;
    if (width > 1280) return 80;
    if (width > 768) return 60;
    if (width > 500) return 40;
    return 30;
  })();

  const fontSize = (() => {
    if (!width) return 40;
    if (width > 1280) return 60;
    if (width > 768) return 50;
    if (width > 500) return 30;
    return 20;
  })();

  return (
    <div
      className="flex items-center flex-col gap-8"
      style={{
        backgroundColor: bgColor ?? "#ffffff",
      }}
    >
      <Title
        titleText={title}
        variant="h3"
        className="text-primary-orange-50"
      />
      <FlipClockCountdown
        to={targetDate}
        labels={["DAYS", "HOURS", "MINUTES", "SECONDS"]}
        labelStyle={{
          fontSize: 16,
          fontWeight: 500,
          textTransform: "uppercase",
          color: "#ffffff",
        }}
        digitBlockStyle={{
          width: blockWidth,
          height: blockWidth,
          fontSize,
          backgroundColor: blockColor ?? "#291E30",
          color: textColor ?? "#ffffff",
        }}
      />
    </div>
  );
};
